<template>
    <el-input v-if="configEnvio.entrada == 'pdf'" style="width: 360px; font-size: 20px; margin-bottom: -30px;"
        placeholder="Título de la publicación" v-model="pubtitulo"></el-input>
    <input id="fileUpload" type="file" name="archivo" aria-label="Archivo" hidden multiple @change="handleFileUpload">
    <span v-if="this.tamanoarchivos < 52428800" id="dropZone" @click="solicitarArchivo" v-on:dragover="handleDragOver"
        v-on:dragleave="dragover = ''" v-on:drop="handleFileUpload"
        :style="`height: ${300 - (33 * file.length)}px; min-height:165px; transition: 0.5s`"
        :class="`solicitarArchivo ${dragover} ${shake ? 'apply-shake' : ''}`">
        <font-awesome-icon v-if="!shake" :icon="dragover != '' ? ['fas', 'circle-check'] : ['fas', 'cloud-arrow-up']" />
        <font-awesome-icon v-else :icon="['fas', 'circle-exclamation']" />
        <div class="el-upload__text">Suelta tus archivos aquí o <em
                :style="`font-style: normal; color: ${working == 'documentos' ? '#0984e3' : 'rgb(230, 162, 60)'}; ${shake ? 'color: #d63031;' : ''} transition: 0.5s;`">haz
                clic para cargar</em></div>
        <div class="el-upload__tip">Solo archivos con un tamaño menor a 20 MB</div>
    </span>
    <span v-else id="dropZone" :style="`height: ${300 - (33 * file.length)}px; min-height:165px; transition: 0.5s`"
        :class="`solicitarArchivo ${shake ? 'apply-shake' : ''}`">
        <i class="el-icon-error"></i>
        <div class="el-upload__text"><em :style="`font-style: normal; color: #d63031; transition: 0.5s;`">Los
                archivos subidos superan los 50 MB</em></div>
    </span>
    <div
        :style="`width: 360px; height: ${0 + (33 * file.length)}px; max-height: 135px; overflow-y: hidden; border-radius: 5px; margin: 50px 0 50px 0; transition: 0.5s; ${file.length > 4 ? 'background: #d3d3d357; overflow-y:scroll;' : ''}`">
        <el-tag v-for="(archivo, index) in file" :key="archivo.file.name"
            @click="file.splice(index, 1); documentos.splice(index, 1)" class="documento"
            style="justify-content: flex-start;">
            <font-awesome-icon :icon="obtenerIcono(archivo.file.name)" />
            {{ archivo.file.name }}
        </el-tag>
    </div>
</template>

<script>
// import { ElNotification } from 'element-plus';
// import { curl } from '@/api.js';
import { getIconPath } from '@/functions.js'
import { mapMutations, mapState } from 'vuex'
export default {
    name: 'EnvioDocumentos',
    watch: {
        file: {
            handler(newVal) {
                this.setFiles(newVal);
            },
            deep: true, // Esto hace que el watch observe profundamente
        },
    },
    data() {
        return {
            loading: false,
            router: this.$router,
            paso: 1,
            tipoDocumento: '',
            file: [],
            tamanoarchivos: 0,
            dragover: false,
            shake: false,
            documentos: [],
        }
    },
    mounted() {
        this.file = this.files;
    },
    computed: {
        ...mapState([
            'datosemp', 'receptores', 'files', 'configEnvio', 'pub_titulo',
        ]),
        pubtitulo: {
            get() {
                return this.pub_titulo;
            },
            set(value) {
                this.setPubTitulo(value);
            }
        },
    },
    methods: {
        ...mapMutations([
            'setDatosemp',
            'setReceptores',
            'setFiles',
            'setConfigEnvio',
            'setPubTitulo'
        ]),
        async handleFileUpload(event) {
            this.loading = true;
            event.stopPropagation();
            event.preventDefault();
            const files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
            this.dragover = '';
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                if (file.size <= 20971520) {
                    console.log(file);
                    let fileObj = {
                        file: file,
                        base64: await this.blobToBase64(file),
                        icon: 'document',
                        tipo: 'info',
                        coorx: null,
                        coory: null
                    };
                    console.log(fileObj.base64);
                    let isDuplicate = this.file.some(filtrado => {
                        return filtrado.file.name === fileObj.file.name && filtrado.file.size === fileObj.file.size && filtrado.file.type === fileObj.file.type;
                    });

                    if (!isDuplicate) {
                        this.file.unshift(fileObj);
                    } else {
                        this.$message.error('Este archivo ya ha sido subido.');
                        this.shakeAnimation();
                    }

                    if (this.configEnvio.accion === 'almacenar') {
                        // Permitir todo tipo de archivos
                        console.log('Acción almacenar: se permiten todos los tipos de archivos.');
                    } else {
                        // Validar si el archivo es PDF
                        if (file.name.split('.').pop().toLowerCase() !== 'pdf') {
                            this.files.shift(); // Asegúrate de remover el archivo inválido
                            this.$message.error('Solo se pueden enviar documentos PDF a firmar.');
                            this.shakeAnimation();
                        }
                    }


                    // if (this.tipoDocumento != 'legal' && this.tipoDocumento != 'firma' && this.file.length > 1) {
                    //     this.file.shift();
                    //     this.$message.error('Solo se permite publicar un archivo.');
                    //     this.shakeAnimation();
                    // }

                } else {
                    this.$message.error('El tamaño del archivo excede el límite.');
                    this.shakeAnimation();
                }
            }
            event.target.value = '';
            this.loading = false;
        },
        handleDragOver(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            evt.dataTransfer.dropEffect = 'copy';
            this.dragover = 'dragover';
        },
        solicitarArchivo() {
            document.getElementById('fileUpload').click();
        },
        async blobToBase64(blob) {
            return new Promise((resolve, _) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.readAsDataURL(blob);
                console.log(_);
            });
        },
        async procesarPages(num) {
            const scale = 4;
            let documento = this.documentos[num];

            for (let i = 1; i <= documento.pdf.numPages; i++) {
                let page = await documento.pdf.getPage(i);
                const viewport = page.getViewport({ scale });

                let canvas = document.querySelector(`#contenedor_0 .canvas_0`);
                let canvasContext = canvas.getContext("2d");
                canvas.height = viewport.height;
                canvas.width = viewport.width;

                let renderTask = page.render({ canvasContext, viewport });
                await renderTask.promise;

                documento.pages.push({
                    page: i,
                    data: canvas.toDataURL("image/jpeg"),
                    cuadros: [],
                });
            }
        },
        shakeAnimation() {
            this.shake = true;
            setTimeout(() => {
                this.shake = false;
            }, 820); // timeout value depending on the duration of the animation
        }, obtenerIcono(nombre) {
            return getIconPath(nombre);
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#colderecha {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: calc(100vh - 20px);
    overflow: auto;
    padding: 10px 0px;

    @media(max-width: 400px) {
        height: 80vh;
    }

    .actionList {
        list-style: none;
        min-width: 50%;

        .tipodocumento {
            display: flex;
            flex-direction: column;
            cursor: pointer;
            padding: 10px;
            border: 2px solid #a9a9a929;
            margin-bottom: 10px;
            border-radius: 10px;
            font-weight: bold;
            transition: 0.5s;
            justify-content: flex-start;

            &:hover {
                background-color: #a9a9a929;
                border-color: #a9a9a929;
            }

            .icono {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 50px;
                height: 50px;
                background: #0985e325;
                border-radius: 10px;
                margin-right: 10px;
            }
        }
    }
}

.solicitarArchivo {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 360px;
    height: 180px;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
    margin: 50px 0 0 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    &.dragover {
        border-color: #0984e3;

        svg {
            color: #0984e3;
        }
    }

    &.apply-shake {
        border-color: #d63031;

        svg {
            color: #d63031;
        }
    }

    svg {
        font-size: 67px;
        color: #C0C4CC;
        line-height: 50px;
        margin-bottom: 10px;
        transition: 0.5s;
    }
}

.documento {
    padding: 0 10px;
    line-height: 30px;
    font-size: 1rem;
    border-radius: 4px;
    box-sizing: border-box;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
    height: auto;
    border: none;
    background: none;
    color: dimgray;
    text-align: left;

    &.success {
        color: #0984e3;
    }

    &.error {
        color: #d63031;
    }
}
</style>